module.exports = __webpack_public_path__ + "img/software_preserve_pattern.e8ad7fec.png";